var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.slideActive.type === 'googleSlides')?_c('AhaInfoBox',{staticClass:"mb-2"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$i18nPresenter.t('questionInfoInstruction'))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }